import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import logger from './common/utils/logger';

import { Provider } from "react-redux";
import store from './common/redux/core/store';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

// AG Grid: Register community + enterprise modules globally before any grid mounts
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import 'ag-grid-enterprise';
import { LicenseManager, SetFilterModule, ColumnsToolPanelModule, FiltersToolPanelModule } from 'ag-grid-enterprise';

if (LicenseManager && process.env.REACT_APP_AG_GRID_LICENSE) {
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE);
}
ModuleRegistry.registerModules([
  AllCommunityModule,
  SetFilterModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule
]);

const cspNonceMeta = typeof document !== 'undefined'
  ? document.querySelector('meta[name="csp-nonce"]')
  : null;
const cspNonce = cspNonceMeta?.getAttribute('content') || '';

const emotionCache = createCache({
  key: 'mui',
  nonce: cspNonce,
  prepend: true,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <CacheProvider value={emotionCache}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </CacheProvider>
  </Provider>
);

// Core Web Vitals are forwarded through the shared operational-event logger so that
// runtime performance/reliability signals are observable via the same "db:operational-log"
// event stream consumed by monitoring tooling, instead of being measured but discarded.
reportWebVitals((metric) => {
  logger.info("web-vital", {
    name: metric?.name,
    value: metric?.value,
    id: metric?.id
  });
});